<template>
  <div :class="!labelsLoaded ? 'main-container' : '' ">
    <Landing v-if="labelsLoaded"/>
  </div>
</template>

<style lang="scss">
  html {
    scroll-behavior: smooth;
  }
</style>

<script>
import { mapState } from 'vuex'
import Landing from '@/views/Landing'

export default {
  components: {
    Landing
  },
  computed: {
    ...mapState(['labelsLoaded', 'loading'])
  },
  data: () => ({
    isDataLoading: true
  }),
  async created () {
    try {
      await this.$store.dispatch('getLabels')
    } catch (e) {
      // eslint-disable-next-line
      console.error(e)
    } finally {
      this.isDataLoading = false
      this.$store.dispatch('sendAnalyticsView')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  min-height: 1000px;
}
</style>
